import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../CSS/App.css';
import '../CSS/ChangePassword.css';

const ChangePassword = () => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [token, setToken] = useState(null);  // State to store the reset token
    const navigate = useNavigate();
    const location = useLocation();  // To extract token from URL

    // Extract token from URL
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const resetToken = queryParams.get('token');
        if (resetToken) {
            setToken(resetToken);
        } else {
            setError('Invalid or expired token');
        }
    }, [location]);

    const handleChangePassword = async (e) => {
        e.preventDefault();

        // Check if new password matches confirm password
        if (newPassword !== confirmPassword) {
            setError('New passwords do not match');
            return;
        }

        try {
            const response = await fetch('https://api.rezepe.com/api/reset-password', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ token, newPassword })
            });

            const data = await response.json();

            if (response.ok) {
                setSuccess('Password changed successfully!');
                setError('');
                setNewPassword('');
                setConfirmPassword('');
            } else {
                setError(data.message || 'Password change failed');
            }
        } catch (err) {
            setError('An error occurred. Please try again later.');
        }
    };

    return (
        <div className="change-password-container">
            <div className="change-password-card">
                <h1>Change Password</h1>
                <form onSubmit={handleChangePassword}>
                    <input
                        type="password"
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        placeholder="Confirm New Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                    />
                    <button type="submit">Change Password</button>
                </form>

                {/* Success and Error Messages */}
                {success && <p className="success">{success}</p>}
                {error && <p className="error">{error}</p>}

                {/* Link back to profile or home */}
                <div className="back-link">
                    <p onClick={() => navigate('/')} className="back-link-text">
                        Back to Home
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ChangePassword;
